import axios from "axios";
import Vue from 'vue';

export default {
    namespaced: true,
    state: () => ({
      list: [],
      unreadCount: 0,
      toast: null,
      canSendMock: false, 
      toastQueue: [],
      maintenanceOverlay: null,
      hasMore: true,      
      currentPage: 1  
    }),
    getters: {
      canSendMock: (state) => state.canSendMock,
    },
    mutations: {
      set(state, notifications) {
        state.list = notifications;
      },
      setUnread(state, count) {
        state.unreadCount = count;
      },
      setMaintenanceOverlay(state, payload) {
        state.maintenanceOverlay = payload;
      },
      clearMaintenanceOverlay(state) {
        state.maintenanceOverlay = null;
      },
      setCanSendMock(state, value) {
        state.canSendMock = value;
      },
      add(state, notification) {
        const exists = state.list.some(n => n.notification_id === notification.notification_id);
        if (!exists) {
          const updatedList = [notification, ...state.list];
          Vue.set(state, 'list', updatedList);
          if (!notification.read_at) {
            state.unreadCount++;
          }
        }
      },
      markRead(state, id) {
        state.list = state.list.map(n => {
          if (n.notification_id === id && !n.read_at) {
            state.unreadCount = Math.max(0, state.unreadCount - 1);
            return { ...n, read_at: new Date() };
          }
          return n;
        });
      },
      // Not needed
      // markAllRead(state) {
      //   state.list = state.list.map(n => ({ ...n, read_at: new Date() }));
      //   state.unreadCount = 0;
      // },
      setToast(state, toast) {
        const exists = state.toastQueue.some(t => t.notification_id === toast.notification_id);
        if (!exists) {
          state.toastQueue.push(toast);
        }
      },
      removeToast(state, index) {
        state.toastQueue.splice(index, 1);
      },
      clearToast(state) {
        state.toast = null;
      },
      setPage(state, page) {
        state.currentPage = page;
      },
      setHasMore(state, hasMore) {
        state.hasMore = hasMore;
      },
      append(state, notifications) {
        const newItems = notifications.filter(n => 
          !state.list.some(existing => existing.notification_id === n.notification_id)
        );
        state.list = [...state.list, ...newItems];
      }
    },
    actions: {
      async fetch({ commit }, page = 1) {
        const { data } = await axios.get('/api/v1/notifications', { params: { page } });

        console.log('🔍 Raw notifications from API:', data.notifications);

        const notifications = data.notifications.map(n => ({
          ...n,
          ...(n.data || {}), // flatten the `data` field
        }));
        if (page === 1) {
          commit('set', notifications);
        } else {
          commit('append', notifications);
        }

        commit('setUnread', parseInt(data.unread_count));
        commit('setPage', page);
        commit('setHasMore', data.has_more);
      },
      async markRead({ commit }, id) {
        await axios.post(`/api/v1/notifications/${id}/read`);
        commit('markRead', id);
      },
      async markAllRead({ commit }) {
        await axios.post(`/api/v1/notifications/read`);
        commit('markAllRead');
      },
      async markSeen() {
        await axios.post('/api/v1/notifications/seen');
      },
      async delete({ commit, state }, id) {
        await axios.delete(`/api/v1/notifications/${id}`);
        const updatedList = state.list.filter(n => n.notification_id !== id);
        commit('set', updatedList);
        const { data: unreadData } = await axios.get('/api/v1/notifications/unread');
        commit('setUnread', parseInt(unreadData.unread_count));
      },
      async checkMockNotificationPermission({ commit }) {
        try {
          const { data } = await axios.get('/api/v1/notifications/mock-meta');
          commit('setCanSendMock', !!data.can_send_mock_notification);
        } catch (e) {
          console.error('Failed to check mock notification permission', e);
          commit('setCanSendMock', false);
        }
      },
      async sendMockNotification(_, { user_id, notification_type, body, data, style, title }) {
        try {
          const { data: responseData } = await axios.post('/api/v1/notifications/send-mock', {
            user_id,
            notification_type,
            title,
            body,
            style,
            data
          });

          return {
            success: true,
            message: responseData.message,
          };
        } catch (error) {
          return {
            success: false,
            message:
              error.response?.data?.message || 'Failed to send mock notification',
          };
        }
      }
    },
  };
  